import { render, staticRenderFns } from "./shouye.vue?vue&type=template&id=f087e4aa&scoped=true"
import script from "./shouye.vue?vue&type=script&lang=js"
export * from "./shouye.vue?vue&type=script&lang=js"
import style0 from "./shouye.vue?vue&type=style&index=0&id=f087e4aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f087e4aa",
  null
  
)

export default component.exports